import styled from '@emotion/styled';
import { Link } from 'react-router';
import { Theme } from '@mui/material/styles';

export const StyledLink = styled(Link)<{ theme?: Theme; color?: string }>`
  text-decoration: none;
  color: ${({ theme, color }) => (color ? color : theme.palette.customSecondary.accent.violet)};
  transition: color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.primary.hover};
  }
`;

export const StyledEntityLink = styled(Link)<{ theme?: Theme; color?: string }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  text-decoration: none;

  p,
  span {
    transition: color 0.3s;
  }

  :hover p,
  :hover span {
    color: ${({ theme }) => theme.palette.customSecondary.primary.hover};
  }
`;
